import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get } from 'lodash';
import classNames from 'classnames';

import { Fields } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';

import IconArrowLeft from 'components/icons/IconArrowLeft';

import {
  requestFetchWorkflowStatuses,
  requestSearchWorkflowStatuses,
} from 'redux/modules/workflowStatuses';

import * as validate from 'utils/validate';

import { accountLoginFail } from 'redux/modules/account';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

const styles = theme => ({
  root: {
    marginTop: 10,
  },
  iconArrowLeft: {
    width: 10,
    height: 10,
    margin: '-2px 0 0 10px',
    verticalAlign: 'middle',
    transform: 'rotate(180deg)',
    color: 'inherit',
  },
  suggestionAutoChange: {
    color: 'inherit',
  },
  state: {
    display: 'inline-block',
    margin: '-2px 0 0 10px',
    width: 12,
    height: 12,
    fontSize: 10,
    lineHeight: '14px',
    padding: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    color: theme.palette.common.white,
    borderRadius: '50%',
  },
  stateIntake: {
    backgroundColor: theme.palette.states.intake,
  },
  stateDelivery: {
    backgroundColor: theme.palette.states.delivery,
  },
  stateBilling: {
    backgroundColor: theme.palette.states.billing,
  },
  stateCollection: {
    backgroundColor: theme.palette.states.collection,
  },
  suggestionContainerIntake: {
    color: theme.palette.states.intake,
  },
  suggestionContainerDelivery: {
    color: theme.palette.states.delivery,
  },
  suggestionContainerBilling: {
    color: theme.palette.states.billing,
  },
  suggestionContainerCollection: {
    color: theme.palette.states.collection,
  },
  gridShrink: {
    flexShrink: 1,
    minWidth: 0,
  },
  gridItem: {
    maxWidth: '60%',
    flexBasis: '60%',
    flexShrink: 1,
    minWidth: 0,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '50%',
      flexBasis: '50%',
    },
  },
});

const ProductClaimStatusFields = ({
  name,
  onFieldFocus,
  onFieldBlur,
  formValues,
  actions,
  account,
  classes,
  disabled,
  ...fields
}) => {
  const statusField = get(fields, `${name}.Status`);
  const typeField = get(fields, `${name}.Type`);
  const selectedStatusIDs = statusField.input.value ? statusField.input.value.map(item => item.value) : [];
  return (
    <Grid
      className={classes.gridItem}
      item
      xs={3}
    >
      <Fields
        id={`${name}.Status`}
        names={[
          `${name}.Status Name`,
          `${name}.Status`,
        ]}
        autosuggestFieldName={`${name}.Status Name`}
        fieldArrayName={`${name}.Status`}
        label="Status"
        component={MultiselectAutosuggestField}
        validate={[validate.required]}
        placeholder="-Status-"
        fullWidth
        labelOverlap
        noWrap
        listWidth="auto"
        renderInputContent={suggestion => suggestion.Name}
        renderSuggestionContent={suggestion => (
          (suggestion['Next Workflow Status'] && suggestion['Next Workflow Status'].ID) ? (
            <div
              className={classNames({
                [classes.suggestionContainerIntake]: suggestion['Next Workflow Status']['Workflow State'].ID === 1,
                [classes.suggestionContainerDelivery]: suggestion['Next Workflow Status']['Workflow State'].ID === 2,
                [classes.suggestionContainerBilling]: suggestion['Next Workflow Status']['Workflow State'].ID === 3,
                [classes.suggestionContainerCollection]: suggestion['Next Workflow Status']['Workflow State'].ID === 4,
              })}
            >
              <span className={classes.suggestionAutoChange}>
                {suggestion.Name}
              </span>
              <IconArrowLeft className={classes.iconArrowLeft} />
              {suggestion['Next Workflow Status']['Workflow State'].ID === 1 && (
                <span className={classNames(classes.state, classes.stateIntake)}>
                  I
                </span>
              )}
              {suggestion['Next Workflow Status']['Workflow State'].ID === 2 && (
                <span className={classNames(classes.state, classes.stateDelivery)}>
                  D
                </span>
              )}
              {suggestion['Next Workflow Status']['Workflow State'].ID === 3 && (
                <span className={classNames(classes.state, classes.stateBilling)}>
                  B
                </span>
              )}
              {suggestion['Next Workflow Status']['Workflow State'].ID === 4 && (
                <span className={classNames(classes.state, classes.stateCollection)}>
                  C
                </span>
              )}
            </div>
          ) : (
            <div>
              {suggestion.Name}
            </div>
          )
        )}
        onSuggestionSelected={(suggestion) => {
          let newStatusValue = [
            ...statusField.input.value || [],
            {
              value: suggestion.ID,
              label: suggestion.Name,
              ...suggestion['Is Delivered'] ? {
                isDelivered: true,
              } : {},
              ...suggestion['Next Workflow Status'] && suggestion['Next Workflow Status'].ID ? {
                nextWorkflowStatusID: suggestion['Next Workflow Status'].ID,
              } : {},
            },
          ];
          statusField.input.onChange(newStatusValue);
          onFieldBlur({
            Status: newStatusValue,
          });
          return '';
        }}
        fetchSuggestions={({ value, limit, offset }) => (
          value.length > 0 || selectedStatusIDs.length > 0
            ? requestSearchWorkflowStatuses({
              filters: [
                ...value.length > 0 ? [{
                  name: 'Name',
                  operation: 'contains',
                  val: value,
                  case_sensitivity: false,
                }] : [],
                ...selectedStatusIDs.map(item => ({
                  name: 'ID',
                  operation: 'ne',
                  val: item,
                })),
              ],
              limit,
              offset,
            }).then(res => res.data,
              (err) => {
                actions.saveRecoverOrder({
                  [account.ID]: {
                    ...formValues,
                    timestamp: new Date().getTime(),
                  },
                });
                if (err.data.error === 'Access Error') {
                  actions.accountLoginFail();
                }
                return err;
              })
            : requestFetchWorkflowStatuses({
              limit,
              offset,
            }).then(res => res.data,
              (err) => {
                actions.saveRecoverOrder({
                  [account.ID]: {
                    ...formValues,
                    timestamp: new Date().getTime(),
                  },
                });
                if (err.data.error === 'Access Error') {
                  actions.accountLoginFail();
                }
                return err;
              })
        )}
        onInputFocus={event => onFieldFocus({
          Status: statusField.input.value,
        })}
        onInputBlur={(event) => {
          onFieldBlur({
            Status: statusField.input.value,
          });
        }}
        onFieldArrayItemDelete={(index) => {
          onFieldFocus({
            Status: statusField.input.value,
          });
          setTimeout(() => {
            onFieldBlur({
              Status: [
                ...statusField.input.value.slice(0, index),
                ...statusField.input.value.slice(index + 1),
              ],
            });
          }, 200);
        }}
        disabled={disabled}
      />
    </Grid>
  );
};

ProductClaimStatusFields.propTypes = {
  name: PropTypes.string.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
    saveRecoverOrder: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconArrowLeft: PropTypes.string.isRequired,
    suggestionAutoChange: PropTypes.string.isRequired,
    gridItem: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimStatusFields.defaultProps = {
  formValues: {},
  disabled: false,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail, saveRecoverOrder }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ProductClaimStatusFields),
);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimStatusFields.js